import React, { useEffect, useState } from 'react';
import inspectionStorage from '../services/inspectionStorage';
import apiService from '../services/apiService';
import cloneManager from '../services/cloneManager';

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f5f3ff, #ede9fe)',
    paddingBottom: '100px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #7c3aed, #6d28d9)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '700',
    margin: 0
  },
  backBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  content: {
    padding: '20px'
  },
  card: {
    background: 'white',
    borderRadius: '16px',
    padding: '18px',
    marginBottom: '16px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
  },
  cardTitle: {
    fontSize: '15px',
    fontWeight: '700',
    color: '#4c1d95',
    marginBottom: '12px'
  },
  formGroup: {
    marginBottom: '12px'
  },
  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '600',
    color: '#374151',
    marginBottom: '6px'
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '2px solid #e5e7eb',
    borderRadius: '10px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box'
  },
  textarea: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '2px solid #e5e7eb',
    borderRadius: '10px',
    background: '#f9fafb',
    color: '#111827',
    boxSizing: 'border-box',
    minHeight: '80px',
    resize: 'vertical'
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '12px'
  },
  radioGroup: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap'
  },
  radioBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 10px',
    borderRadius: '10px',
    border: '2px solid #e5e7eb',
    background: '#f9fafb',
    cursor: 'pointer',
    fontSize: '13px'
  },
  radioBtnActive: {
    border: '2px solid #7c3aed',
    background: '#ede9fe',
    color: '#4c1d95',
    fontWeight: '600'
  },
  saveSection: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '16px 20px',
    background: 'white',
    boxShadow: '0 -4px 16px rgba(0,0,0,0.1)'
  },
  saveButton: {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(135deg, #7c3aed, #6d28d9)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer'
  }
};

export default function Etape1InfosThermographieMobile({ mission, onBack, onSave }) {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [clients, setClients] = useState([]);
  const [etablissements, setEtablissements] = useState([]);
  const [inspecteurs, setInspecteurs] = useState([]);
  const [parametres, setParametres] = useState(null);
  const [loadingRefs, setLoadingRefs] = useState(false);
  const [q19, setQ19] = useState({
    client_id: '',
    etablissement_id: '',
    inspecteur_id: '',
    company_name: '',
    company_activity: '',
    control_date: '',
    control_period: '',
    is_first_control: null,
    previous_report_provided: null,
    previous_control_date: '',
    operator_name: '',
    operator_company_type: 'intervenante',
    operator_company_name_intervenante: '',
    operator_company_name_utilisatrice: '',
    buildings_concerned: '',
    equipment_list_complete: null,
    equipment_list_missing: '',
    all_equipment_controlled: null,
    equipment_not_controlled_details: '',
    external_installation_detected: null,
    external_installation_type: '',
    site_adresse: ''
  });

  useEffect(() => {
    loadData();
  }, [mission.id]);

  useEffect(() => {
    loadReferences();
  }, []);

  const applyAutoFill = (data) => {
    const next = { ...data };
    const inspector = cloneManager.getInspecteur();
    if (!next.inspecteur_id && inspector?.id) {
      next.inspecteur_id = inspector.id;
    }
    if (!next.operator_name && inspector) {
      const fullName = `${inspector.prenom || ''} ${inspector.nom || ''}`.trim();
      if (fullName) {
        next.operator_name = fullName;
      }
    }
    if (!next.operator_company_type) {
      next.operator_company_type = 'intervenante';
    }
    if (next.operator_company_type === 'intervenante' && !next.operator_company_name_intervenante) {
      const companyName = parametres?.company_name || cloneManager.getCompanyName();
      const address =
        parametres?.headquarters_address ||
        parametres?.adresse_siege ||
        parametres?.company_address ||
        '';
      const composed = [companyName, address].filter(Boolean).join('\n').trim();
      if (composed) {
        next.operator_company_name_intervenante = composed;
      }
    }
    return next;
  };

  useEffect(() => {
    setQ19((prev) => applyAutoFill(prev));
  }, [parametres]);

  const loadData = async () => {
    setLoading(true);
    try {
      const stored = await inspectionStorage.getStep(mission.id, 'rapport_q19_data');
      const base = stored || {};
      setQ19((prev) =>
        applyAutoFill({
          ...prev,
          ...base,
          client_id: base.client_id || mission.client_id || '',
          etablissement_id: base.etablissement_id || mission.etablissement_id || '',
          company_name: base.company_name || mission.client_nom || '',
          company_activity: base.company_activity || mission.activite_etablissement || '',
          inspecteur_id: base.inspecteur_id || mission.inspecteur_id || '',
          site_adresse: base.site_adresse || mission.site_adresse || '',
          control_date: base.control_date || mission.date_verification || ''
        })
      );
      if (base.etablissement_id || mission.etablissement_id) {
        await loadEtablissements(base.client_id || mission.client_id);
      }
    } catch (error) {
      console.error('❌ Erreur chargement thermo:', error);
    } finally {
      setLoading(false);
    }
  };

  const loadReferences = async () => {
    setLoadingRefs(true);
    try {
      const [cachedClients, cachedInspecteurs, cachedParams] = await Promise.all([
        inspectionStorage.get('clients_cache'),
        inspectionStorage.get('inspecteurs_cache'),
        inspectionStorage.get('parametres_cache')
      ]);
      if (Array.isArray(cachedClients) && cachedClients.length > 0) {
        setClients(cachedClients);
      }
      if (Array.isArray(cachedInspecteurs) && cachedInspecteurs.length > 0) {
        setInspecteurs(cachedInspecteurs);
      }
      if (cachedParams) {
        setParametres(cachedParams);
      }

      const [clientsRes, inspecteursRes, paramsRes] = await Promise.all([
        apiService.getClientsForFrais(),
        apiService.getInspecteurs(),
        apiService.getParametres()
      ]);

      if (clientsRes?.success && Array.isArray(clientsRes.clients)) {
        setClients(clientsRes.clients);
        await inspectionStorage.set('clients_cache', clientsRes.clients);
      }
      if (Array.isArray(inspecteursRes)) {
        setInspecteurs(inspecteursRes);
        await inspectionStorage.set('inspecteurs_cache', inspecteursRes);
      }
      if (paramsRes?.success && Array.isArray(paramsRes.parametres)) {
        const first = paramsRes.parametres[0] || null;
        setParametres(first);
        await inspectionStorage.set('parametres_cache', first);
      }
    } catch (error) {
      console.error('❌ Erreur chargement références:', error);
    } finally {
      setLoadingRefs(false);
    }
  };

  const loadEtablissements = async (clientId) => {
    if (!clientId) {
      setEtablissements([]);
      return;
    }
    try {
      const cacheKey = `etablissements_client_${clientId}`;
      const cached = await inspectionStorage.get(cacheKey);
      if (Array.isArray(cached) && cached.length > 0) {
        setEtablissements(cached);
      }
      const res = await apiService.getClientEtablissements(clientId);
      if (res?.success && Array.isArray(res.etablissements)) {
        setEtablissements(res.etablissements);
        await inspectionStorage.set(cacheKey, res.etablissements);
      }
    } catch (error) {
      console.error('❌ Erreur chargement établissements:', error);
    }
  };

  const handleClientChange = async (clientId) => {
    const client = clients.find(c => c.id === clientId);
    setQ19(prev => ({
      ...prev,
      client_id: clientId,
      etablissement_id: '',
      company_name: client ? (client.entreprise || `${client.nom || ''} ${client.prenom || ''}`.trim()) : prev.company_name,
      company_activity: client?.activite || prev.company_activity
    }));
    await loadEtablissements(clientId);
  };

  const handleEtablissementChange = (etablissementId) => {
    const etab = etablissements.find(e => e.id === etablissementId);
    setQ19(prev => ({
      ...prev,
      etablissement_id: etablissementId,
      company_activity: etab?.activite || prev.company_activity,
      site_adresse: etab ? `${etab.adresse || ''} ${etab.code_postal || ''} ${etab.ville || ''}`.trim() : prev.site_adresse
    }));
  };

  const handleInspecteurChange = (inspecteurId) => {
    const insp = inspecteurs.find(i => i.id === inspecteurId);
    setQ19(prev => ({
      ...prev,
      inspecteur_id: inspecteurId,
      operator_name: insp ? `${insp.prenom || ''} ${insp.nom || ''}`.trim() : prev.operator_name
    }));
  };

  const updateField = (field, value) => {
    setQ19(prev => ({ ...prev, [field]: value }));
  };

  const toggleRadio = (field, value) => {
    updateField(field, value);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const stored = await inspectionStorage.getStep(mission.id, 'rapport_q19_data');
      const merged = { ...(stored || {}), ...q19 };
      await inspectionStorage.saveStep(mission.id, 'rapport_q19_data', merged);
      if (onSave) onSave(q19);
      onBack();
    } catch (error) {
      console.error('❌ Erreur sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#f5f3ff' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '40px', height: '40px', border: '4px solid #e5e7eb', borderTopColor: '#7c3aed', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }}></div>
          <p style={{ marginTop: '16px', color: '#4c1d95', fontWeight: '500' }}>Chargement...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <h1 style={styles.headerTitle}>Thermographie - Infos</h1>
        <button style={styles.backBtn} onClick={handleSave} disabled={saving}>
          {saving ? '⏳' : '💾'}
        </button>
      </div>

      <div style={styles.content}>
        <div style={styles.card}>
          <div style={styles.cardTitle}>👥 Sélection client</div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Client</label>
            <select
              style={styles.input}
              value={q19.client_id || ''}
              onChange={(e) => handleClientChange(e.target.value)}
              disabled={!!q19.client_id}
            >
              <option value="">Choisir un client...</option>
              {clients.map((client) => (
                <option key={client.id} value={client.id}>
                  {(client.entreprise || `${client.nom || ''} ${client.prenom || ''}`.trim()) || 'Client'}
                </option>
              ))}
            </select>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Établissement</label>
            <select
              style={styles.input}
              value={q19.etablissement_id || ''}
              onChange={(e) => handleEtablissementChange(e.target.value)}
              disabled={!q19.client_id || etablissements.length === 0 || !!q19.etablissement_id}
            >
              <option value="">{q19.client_id ? 'Choisir un établissement...' : 'Sélectionnez un client'}</option>
              {etablissements.map((etab) => (
                <option key={etab.id} value={etab.id}>
                  {etab.nom || etab.ville || etab.id}
                </option>
              ))}
            </select>
          </div>
          {loadingRefs && (
            <div style={{ fontSize: '12px', color: '#6b7280' }}>Chargement des références...</div>
          )}
        </div>

        <div style={styles.card}>
          <div style={styles.cardTitle}>🧑‍🔧 Vérificateur</div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Inspecteur</label>
            <select
              style={styles.input}
              value={q19.inspecteur_id || ''}
              onChange={(e) => handleInspecteurChange(e.target.value)}
            >
              <option value="">Sélectionner un vérificateur...</option>
              {inspecteurs.map((insp) => (
                <option key={insp.id} value={insp.id}>
                  {`${insp.prenom || ''} ${insp.nom || ''}`.trim()}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div style={styles.card}>
          <div style={styles.cardTitle}>🏢 Entreprise utilisatrice</div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Nom / Raison sociale</label>
            <input style={styles.input} value={q19.company_name} onChange={(e) => updateField('company_name', e.target.value)} />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Activité</label>
            <input style={styles.input} value={q19.company_activity} onChange={(e) => updateField('company_activity', e.target.value)} />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Adresse du site</label>
            <input style={styles.input} value={q19.site_adresse || ''} onChange={(e) => updateField('site_adresse', e.target.value)} />
          </div>
        </div>

        <div style={styles.card}>
          <div style={styles.cardTitle}>📅 Contrôle</div>
          <div style={styles.row}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Date du contrôle</label>
              <input type="date" style={styles.input} value={q19.control_date || ''} onChange={(e) => updateField('control_date', e.target.value)} />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.label}>Période</label>
              <input style={styles.input} value={q19.control_period || ''} onChange={(e) => updateField('control_period', e.target.value)} placeholder="Ex: du 10 au 12/02" />
            </div>
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Premier contrôle thermographique</label>
            <div style={styles.radioGroup}>
              <button type="button" style={{ ...styles.radioBtn, ...(q19.is_first_control === true ? styles.radioBtnActive : {}) }} onClick={() => toggleRadio('is_first_control', true)}>Oui</button>
              <button type="button" style={{ ...styles.radioBtn, ...(q19.is_first_control === false ? styles.radioBtnActive : {}) }} onClick={() => toggleRadio('is_first_control', false)}>Non</button>
            </div>
          </div>
          {q19.is_first_control === false && (
            <>
              <div style={styles.formGroup}>
                <label style={styles.label}>Dossier précédent fourni</label>
                <div style={styles.radioGroup}>
                  <button type="button" style={{ ...styles.radioBtn, ...(q19.previous_report_provided === true ? styles.radioBtnActive : {}) }} onClick={() => toggleRadio('previous_report_provided', true)}>Oui</button>
                  <button type="button" style={{ ...styles.radioBtn, ...(q19.previous_report_provided === false ? styles.radioBtnActive : {}) }} onClick={() => toggleRadio('previous_report_provided', false)}>Non</button>
                </div>
              </div>
              <div style={styles.formGroup}>
                <label style={styles.label}>Date du contrôle précédent</label>
                <input type="date" style={styles.input} value={q19.previous_control_date || ''} onChange={(e) => updateField('previous_control_date', e.target.value)} />
              </div>
            </>
          )}
        </div>

        <div style={styles.card}>
          <div style={styles.cardTitle}>👷 Opérateur</div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Nom de l’opérateur</label>
            <input style={styles.input} value={q19.operator_name || ''} onChange={(e) => updateField('operator_name', e.target.value)} />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Société de l’opérateur</label>
            <div style={styles.radioGroup}>
              <button type="button" style={{ ...styles.radioBtn, ...(q19.operator_company_type === 'intervenante' ? styles.radioBtnActive : {}) }} onClick={() => toggleRadio('operator_company_type', 'intervenante')}>Intervenante</button>
              <button type="button" style={{ ...styles.radioBtn, ...(q19.operator_company_type === 'utilisatrice' ? styles.radioBtnActive : {}) }} onClick={() => toggleRadio('operator_company_type', 'utilisatrice')}>Utilisatrice</button>
            </div>
          </div>
          {q19.operator_company_type === 'intervenante' && (
            <div style={styles.formGroup}>
              <label style={styles.label}>Nom + adresse</label>
              <textarea style={styles.textarea} value={q19.operator_company_name_intervenante || ''} onChange={(e) => updateField('operator_company_name_intervenante', e.target.value)} />
            </div>
          )}
          {q19.operator_company_type === 'utilisatrice' && (
            <div style={styles.formGroup}>
              <label style={styles.label}>Nom + adresse</label>
              <textarea style={styles.textarea} value={q19.operator_company_name_utilisatrice || ''} onChange={(e) => updateField('operator_company_name_utilisatrice', e.target.value)} />
            </div>
          )}
        </div>

        <div style={styles.card}>
          <div style={styles.cardTitle}>🏭 Informations contrôle</div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Bâtiments concernés</label>
            <input style={styles.input} value={q19.buildings_concerned || ''} onChange={(e) => updateField('buildings_concerned', e.target.value)} />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Liste équipements complète</label>
            <div style={styles.radioGroup}>
              <button type="button" style={{ ...styles.radioBtn, ...(q19.equipment_list_complete === true ? styles.radioBtnActive : {}) }} onClick={() => toggleRadio('equipment_list_complete', true)}>Oui</button>
              <button type="button" style={{ ...styles.radioBtn, ...(q19.equipment_list_complete === false ? styles.radioBtnActive : {}) }} onClick={() => toggleRadio('equipment_list_complete', false)}>Non</button>
            </div>
          </div>
          {q19.equipment_list_complete === false && (
            <div style={styles.formGroup}>
              <label style={styles.label}>Équipements manquants</label>
              <textarea style={styles.textarea} value={q19.equipment_list_missing || ''} onChange={(e) => updateField('equipment_list_missing', e.target.value)} />
            </div>
          )}
          <div style={styles.formGroup}>
            <label style={styles.label}>Tous les équipements contrôlés</label>
            <div style={styles.radioGroup}>
              <button type="button" style={{ ...styles.radioBtn, ...(q19.all_equipment_controlled === true ? styles.radioBtnActive : {}) }} onClick={() => toggleRadio('all_equipment_controlled', true)}>Oui</button>
              <button type="button" style={{ ...styles.radioBtn, ...(q19.all_equipment_controlled === false ? styles.radioBtnActive : {}) }} onClick={() => toggleRadio('all_equipment_controlled', false)}>Non</button>
            </div>
          </div>
          {q19.all_equipment_controlled === false && (
            <div style={styles.formGroup}>
              <label style={styles.label}>Détails équipements non contrôlés</label>
              <textarea style={styles.textarea} value={q19.equipment_not_controlled_details || ''} onChange={(e) => updateField('equipment_not_controlled_details', e.target.value)} />
            </div>
          )}
          <div style={styles.formGroup}>
            <label style={styles.label}>Installation extérieure détectée</label>
            <div style={styles.radioGroup}>
              <button type="button" style={{ ...styles.radioBtn, ...(q19.external_installation_detected === true ? styles.radioBtnActive : {}) }} onClick={() => toggleRadio('external_installation_detected', true)}>Oui</button>
              <button type="button" style={{ ...styles.radioBtn, ...(q19.external_installation_detected === false ? styles.radioBtnActive : {}) }} onClick={() => toggleRadio('external_installation_detected', false)}>Non</button>
            </div>
          </div>
          {q19.external_installation_detected === true && (
            <div style={styles.formGroup}>
              <label style={styles.label}>Type d’installation</label>
              <input style={styles.input} value={q19.external_installation_type || ''} onChange={(e) => updateField('external_installation_type', e.target.value)} />
            </div>
          )}
        </div>
      </div>

      <div style={styles.saveSection}>
        <button style={{ ...styles.saveButton, ...(saving ? { opacity: 0.6, cursor: 'not-allowed' } : {}) }} onClick={handleSave} disabled={saving}>
          {saving ? '⏳ Sauvegarde...' : '💾 Sauvegarder'}
        </button>
      </div>
    </div>
  );
}
